import React, { useEffect, useState } from "react"
import { useAuthUser } from "react-auth-kit"
import { useNavigate, useOutletContext } from "react-router-dom"
import { Link } from "react-router-dom"

import Overlay from "../../components/Overlay"

import Lottie from "lottie-react"
import animationData from "../../animations/robot.json"

const ChatPage = () => {
	const auth = useAuthUser()
	const user = auth()
	const navigate = useNavigate()
	const { handleCustomAction } = useOutletContext()

	const [showMenu, setShowMenu] = useState(false)
	const [loading, setLoading] = useState(false)

	const createChat = async () => {
		setLoading(true)
		try {
			const response = await fetch(
				`https://api.baobabcircle.com/pharmacy/chats`,
				{
					method: "POST",
					headers: {
						Authorization: `Bearer ${user.apikey}`,
						// Authorization: `Bearer zmsBkCwHuLVZIfJ2GA3sYdwZc1bqRvP9fLMqlHA3rPsPiYSwcRjW8mGY9MRKH0Kw`,
						Accept: "application/json",
						"Content-Type": "application/json",
					},
				}
			)
			const result = await response.json()
			navigate(`/chat/${result.id}`)
			if (result.error) {
				setLoading(false)
				return
			}
		} catch (error) {
			setLoading(false)
			console.log(error)
		} finally {
			setLoading(false)
		}
	}

	useEffect(() => {
		return function () {
			window.scrollTo(0, 0)
		}
	}, [])

	return (
		<section className="w-full h-[100dvh]">
			<div className="relative w-full h-full">
				<div className="w-full pt-[30px] h-full relative overflow-y-scroll flex bg-white">
					<div className="flex pb-[80px] my-auto w-full flex-col px-[16px]">
						<div className="w-[10rem] h-[10rem] mx-auto">
							<Lottie animationData={animationData} loop={true} />
						</div>
						<div className="flex flex-col gap-[0.3rem] mt-[2rem]">
							<p className="m-auto w-full font-normal font-['DM Sans'] text-[#6C6C6C] text-center text-[14px]">
								Hello, I am Pharma
							</p>
							<p className="text-[18px] font-['DM Sans'] w-full text-center font-[500]">
								How can I help you today
							</p>
						</div>

						<ul className="flex flex-row gap-[3rem] justify-center mt-[2rem] my-[5dvh]">
							<li className="flex flex-col">
								<button
									onClick={handleCustomAction}
									className="mx-auto w-[40px] h-[40px] flex rounded-[5rem] p-[0.5rem] bg-[#f6f7ff]"
								>
									<svg
										className="w-[24px] h-[24px] m-auto"
										viewBox="0 0 24 24"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M20 12H10M20 5H4M20 19H4"
											stroke="black"
											strokeWidth="2"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
									</svg>
								</button>
								<span className="text-black text-center text-[12px] leading-1 pt-[0.4rem] ">
									Old Chats
								</span>
							</li>
							{/* <li className="flex flex-col">
								<button
									className="mx-auto w-[40px] h-[40px] flex rounded-[5rem] p-[0.5rem] bg-[#f6f7ff]"
									onClick={createChat}
								>
									<svg
										className="w-[24px] h-[24px] m-auto"
										viewBox="0 0 18 18"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M9 17C13.4184 17 17 13.4184 17 9C17 4.5816 13.4184 1 9 1C4.5816 1 1 4.5816 1 9C1 10.28 1.3008 11.4896 1.8344 12.5624C1.9768 12.8472 2.024 13.1728 1.9416 13.4808L1.4656 15.2616C1.41846 15.4378 1.4185 15.6234 1.46572 15.7996C1.51295 15.9758 1.60569 16.1365 1.73465 16.2655C1.86361 16.3946 2.02424 16.4874 2.20042 16.5347C2.3766 16.5821 2.56214 16.5822 2.7384 16.5352L4.5192 16.0584C4.8283 15.9803 5.15531 16.0182 5.4384 16.1648C6.54476 16.7156 7.76409 17.0016 9 17Z"
											stroke="black"
											stroke-width="1.5"
										/>
										<path
											d="M5.8 7.8H12.2M5.8 10.6H10.2"
											stroke="#F19B3E"
											stroke-width="1.5"
											stroke-linecap="round"
										/>
									</svg>
								</button>
								<span className="text-black text-center text-[12px] leading-1 pt-[0.4rem] ">
									New Chat
								</span>
							</li> */}
							<li className="flex flex-col">
								<Link
									to="/"
									className="mx-auto w-[40px] h-[40px] flex rounded-[5rem] p-[0.5rem] bg-[#f6f7ff]"
								>
									<svg
										className="w-[18px] h-[18px] m-auto"
										viewBox="0 0 18 18"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M1 1L17 17M1 17L17 1"
											stroke="black"
											stroke-width="1.8"
											stroke-linecap="round"
											stroke-linejoin="round"
										/>
									</svg>
								</Link>
								<span className="text-black text-center text-[12px] leading-1 pt-[0.4rem] ">
									Exit Chats
								</span>
							</li>
						</ul>

						<div className="flex flex-col md:flex-row gap-[1rem] justify-center items-center">
							<button
								onClick={createChat}
								disabled={loading}
								className="text-white sm:order-2 bg-[#f2994a] md:w-[150px] w-full  rounded-[3px] flex h-[32px] px-[1rem]"
							>
								<span className="m-auto flex justify-center text-[12px] gap-[0.2rem]">
									{!loading && <span>Start Chatting</span>}
									{loading && <span>Loading...</span>}
								</span>
							</button>
						</div>
					</div>
				</div>
				<Overlay
					isOpen={showMenu}
					onClose={() => {
						setShowMenu(false)
					}}
				/>
			</div>
		</section>
	)
}
export default ChatPage
